import axios from 'axios'

export default class RestApi {
  constructor () {
    this.tokenAuth = '95accd67-24a9-44e6-9a38-3b210a78867d';
    this.remoteHost = 'http://localhost:7071';
  }
  /**
   * Sent data to API
   * @param {String} id uniq form id
   * @param {String} codeQuestion uniq question code
   * @param {String} value Answer
   * @param {String} clientName
   * @param {Number} schemaId
   * @param {String} answerObject
   * @constructor
   */
  static RemoteStore (id, codeQuestion, value, clientName, schemaId, answerObject) {
    const url = `${RestApi.remoteHost}/api/StoredData`
    return new Promise((resolve, reject) => {
      axios.post(url, {
        id: id,
        codeQuestion: codeQuestion,
        value: value,
        clientName: clientName,
        questionnaireSchemaId: schemaId,
        answerObject: answerObject
      })
        .then(function (response) {
          console.log(response)
          resolve(response)
        })
        .catch(function (error) {
          console.log(error)
          reject(error)
        })
    })
  }

  /**
   * Get all answer for Questionnaire Schema
   * @param {string} schemaId
   * @constructor
   */
  static AnswersBySchema (schemaId) {
    const url = `${RestApi.remoteHost}/api/AnswersBySchema/${schemaId}`
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(function (response) {
          console.log(response)
          resolve(response)
        })
        .catch(function (error) {
          console.log(error)
          reject(error)
        })
    })
  }

  static GetAnswersById (answerId) {
    const url = `${RestApi.remoteHost}/api/GetAnswersById/${answerId}`
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(function (response) {
          console.log(response)
          resolve(response)
        })
        .catch(function (error) {
          console.log(error)
          reject(error)
        })
    })
  }

  static QuestionnaireStatBySchema (schemaId) {
    const url = `${RestApi.remoteHost}/api/QuestionnaireStatBySchema/${schemaId}`
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(function (response) {
          console.log(response)
          resolve(response)
        })
        .catch(function (error) {
          console.log(error)
          reject(error)
        })
    })
  }

  static Schemas () {
    const url = `${RestApi.remoteHost}/api/Schemas`
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(function (response) {
          console.log(response)
          resolve(response)
        })
        .catch(function (error) {
          console.log(error)
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/RestApi.js